import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getOnTimeFulfillmentRate = {
  name: "getOnTimeFulfillmentRate" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
